/**
 * 郵便番号から住所を自動入力する機能
 * @param {Object} config - フォーム要素のIDマッピング
 * @param {string} config.zip - 郵便番号入力欄のID
 * @param {string} [config.pref] - 都道府県セレクトのID
 * @param {string} [config.city] - 市区町村入力欄のID
 * @param {string} [config.address] - 丁番地入力欄のID
 * @param {string} [config.building] - 建物名入力欄のID（フォーカス移動先）
 * @param {string} [config.fullAddress] - 都道府県+市区町村+丁番地を一括セットするID
 */
const initZipAutoFill = (config) => {
    const zipElement = document.getElementById(config.zip);
    if (!zipElement) return;

    /**
     * 郵便番号から住所を取得してフォームにセットする
     * @param {boolean} isUserInput - ユーザー入力によるトリガーかどうか
     */
    const fetchAndFillAddress = async (isUserInput = true) => {
        const cleanZip = zipElement.value.replace(/-/g, "");

        if (cleanZip.length !== 7) return;

        try {
            const response = await fetch(
                `https://api.zipaddress.net/?zipcode=${cleanZip}`
            );
            const data = await response.json();

            if (data.code !== 200) {
                if (isUserInput) {
                    alert("住所が見つかりませんでした。");
                }
                return;
            }

            // 都道府県
            if (config.pref) {
                const prefElement = document.getElementById(config.pref);
                if (prefElement && prefElement.tagName === "SELECT") {
                    const matchOption = Array.from(prefElement.options).find(
                        (option) => option.text === data.data.pref
                    );
                    if (matchOption) {
                        prefElement.value = matchOption.value;
                        prefElement.dispatchEvent(new Event("change", { bubbles: true }));
                    }
                }
            }

            // 市区町村
            if (config.city) {
                const cityElement = document.getElementById(config.city);
                if (cityElement) {
                    cityElement.value = data.data.city;
                }
            }

            // 丁番地
            if (config.address) {
                const addressElement = document.getElementById(config.address);
                if (addressElement) {
                    addressElement.value = data.data.town;
                }
            }

            // 都道府県+市区町村+丁番地を一括セット（1つのフィールドにまとめる場合）
            if (config.fullAddress) {
                const fullAddressElement = document.getElementById(config.fullAddress);
                if (fullAddressElement) {
                    fullAddressElement.value =
                        data.data.pref + data.data.city + data.data.town;
                }
            }

            // フォーカス移動（ユーザー入力時のみ）
            if (isUserInput) {
                const focusTarget = config.building || config.fullAddress;
                if (focusTarget) {
                    const focusElement = document.getElementById(focusTarget);
                    if (focusElement) {
                        focusElement.focus();
                        focusElement.setSelectionRange(
                            focusElement.value.length,
                            focusElement.value.length
                        );
                    }
                }
            }
        } catch (error) {
            console.error("エラー:", error);
            if (isUserInput) {
                alert("住所の取得中にエラーが発生しました。");
            }
        }
    };

    // ユーザー入力時
    zipElement.addEventListener("input", () => fetchAndFillAddress(true));

    // ページ読み込み時（既に値がある場合）
    if (zipElement.value.replace(/-/g, "").length === 7) {
        fetchAndFillAddress(false);
    }
};

const main = () => {
    // 元のフォーム（個別フィールド版）
    initZipAutoFill({
        zip: "zip",
        pref: "pref",
        city: "city",
        address: "address",
        building: "building",
    });

// 物件フォーム（住所を1フィールドにまとめる版）
    initZipAutoFill({
        zip: "estate_zip",
        fullAddress: "estate_address",
    });
}

export default main;
